/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useParams } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PageHeader from '../../layouts/page-header/PageHeader';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useState } from 'react';
import BlogSidebar from './sidebar';
import moment from 'moment/moment';
import '../blog/blog.scss';
import { formatMonth } from '../../data/format-month';
import { bilimMerkezAPI, merkezMedia } from '../../api';
import BlurImage from '../../component/blur-image';
import replaceWithSpace from '../../data/replace';
import Loading from '../../component/Loading';
import { HiOutlineEye } from 'react-icons/hi2';

function BlogSingle() {
  let { id } = useParams();
  const { t } = useTranslation();
  const [data, setData] = useState({});
  const language = localStorage.getItem('i18nextLng');
  const [loading, setLoading] = useState(true);

  const formatDate = (date) => {
    const month = date?.split('T')[0].split('-')[1];
    return `${formatMonth(month, language)} ${moment(date).format(
      `DD, YYYY HH:mm`
    )}`;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const lang = language === 'tk' ? 'tm' : language;
    setLoading(true);
    bilimMerkezAPI
      .get(`/competition/${id}?lang=${lang}`)
      .then((req) => {
        setData(req.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  }, [language, id]);

  return (
    <>
      <div className="tw-w-full tw-mt-60">
        <PageHeader
          colSize="col-md-10"
          title={t('competitions')}
          PagaHeaderBg={'/images/bg.svg'}
          breadCrumbItems={[{ label: t('home'), path: '/' }]}
        />
        <div className="content-wrapper page-template">
          <Container>
            <Row className="justify-content-center">
              {loading ? (
                <div className="tw-w-full tw-flex tw-flex-row tw-justify-center tw-items-center">
                  <Loading style={{ width: '10%' }} />
                </div>
              ) : (
                <Col xl={8} lg={12}>
                  <article className="about-post blog-post">
                    <div className="entry-content">
                      <div className="entry-meta">
                        <ul>
                          <li key="meta-category">
                            <img
                              src="/images/calendar.svg"
                              className=""
                              alt="calendar"
                            />
                          </li>
                          <li key="meta-date" className="">
                            <div className="tw-flex tw-flex-row tw-items-center tw-gap-x-1">
                              {Object.keys(data).length && <div>{formatDate(data.published_date)}</div> }
                              <div className="tw-w-8" />
                              <HiOutlineEye size={22} className="tw-size-4"/>
                              <span>{data.views ?? 0}</span>
                            </div>
                          </li>
                        </ul>
                      </div>
                      <h4 className="entry-title pt-2">
                        {Object.keys(data).length ? data.title : ''}
                      </h4>
                    </div>
                    <BlurImage
                      className="tw-w-full tw-aspect-[3/2]"
                      src={merkezMedia(data.image || data.image_thumbnail)}
                      alt={data.title}
                    />
                    <div className="entry-content article-content">
                      <div className="">
                        {Object.keys(data).length && (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: replaceWithSpace(data.content),
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </article>
                </Col>
              )}
            </Row>
            {loading ? null : <BlogSidebar news_id={id} />}
          </Container>
        </div>
      </div>
    </>
  );
}

export default BlogSingle;
